globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalServiceDealManageDiscountVouchers = (function(superClass)
{
    utils.extend(ModalServiceDealManageDiscountVouchers, superClass);

    function ModalServiceDealManageDiscountVouchers($html) {
      return ModalServiceDealManageDiscountVouchers.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalServiceDealManageDiscountVouchers.prototype, {
      init: function()
      {
        $(".styled, .multiselect-container input").uniform({
          radioClass: 'choice'
        });
        backoffice.initSelect2(this.$html.find('.select'));
        this.$html.find('.table').each(function() { $(this).sbBoManageTableRadioSelectRows(); });

        ModalServiceDealManageDiscountVouchers.__super__.init.apply(this, arguments);
      },
      callbackSuccess: function(data) {
        if(data.response) {
          location.reload();
        }

        ModalServiceDealManageDiscountVouchers.__super__.callbackSuccess.apply(this, arguments);
      }
    });

    return ModalServiceDealManageDiscountVouchers;
})(backoffice.ModalMain);
